var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFillLinkCircleLm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#jottacloud_FillLinkCircleLM.svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#46CD85"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m9.188 13.633 4.443-4.443a.835.835 0 0 1 1.18 1.18l-4.443 4.443a.834.834 0 1 1-1.18-1.18m9.095-7.915a4.17 4.17 0 0 0-5.892 0L10.3 7.808a.835.835 0 0 0 1.18 1.18L13.568 6.9a2.5 2.5 0 0 1 3.535 3.535l-2.09 2.086a.834.834 0 1 0 1.18 1.18l2.089-2.086a4.17 4.17 0 0 0-.003-5.896zm-5.761 9.295-2.088 2.089A2.5 2.5 0 0 1 6.9 13.566l2.087-2.088a.834.834 0 1 0-1.18-1.18l-2.086 2.09a4.167 4.167 0 1 0 5.893 5.892l2.087-2.088a.835.835 0 0 0-1.18-1.18z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "jottacloud_FillLinkCircleLM.svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgFillLinkCircleLm;